import Auth from "src/auth";

import { authenticationService } from "src/_services";

const developmentURL = process.env.REACT_APP_URL;
export const downloadUrl =
  process.env.REACT_APP_ENV === "production"
    ? `https://cgmf.project247.in`
    : developmentURL;

export const API_BASE_URL =
  process.env.REACT_APP_ENV === "production"
    ? `https://cgmf.project247.in/api/`
    : `${developmentURL}/api/`;

export const PAYMNET_CANCEL_URL =
  process.env.REACT_APP_ENV === "production"
    ? `https://cgmf.project247.in/api/PaymentResponse/PaymentCancel`
    : `${developmentURL}/api/PaymentResponse/PaymentCancel`;

// export const PG_BASE_URL =
//   process.env.REACT_APP_ENV === "production"
//     ? `https://www.b2biz.co.in`
//     : `https://demo.b2biz.co.in`;

export const PG_BASE_URL =
  process.env.REACT_APP_ENV === "production"
    ? `https://igateway.icici.bank.in/Pay2corp`
    : `https://uat-onprem-dmz-hybrid.icici.bank.in/Pay2corp_Generic`;

export const PG_BASE_URL_PAYMENT =
  process.env.REACT_APP_ENV === "production"
    ? `https://generic.ipay2corp.icici.bank.in/gp2c-api`
    : `https://generic.ipay2corpuat.icici.bank.in/gp2c-api`;


export const PG_WT_CLIENT_CODE =
  process.env.REACT_APP_ENV === "production" ? `WT-1265` : `WT-1304`;

export const PG_WALLETKEY =
  process.env.REACT_APP_ENV === "production"
    ? `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCy2DU5bVedxYugU13I7GBMBr3lKg86giypeyg58GG0GFZeXkz7d/UmkbPD69OIujgVRoHGJ4NsYmt5phIof8kpRpNYp9bQXrk4hrobjPmazS/CcY4iAibturq6s6SuZSzFI9MrfceyzBx6XSxYvnKnuGcUnGy1ire4V5pbX+VkcwIDAQAB`
    : `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCFdzI00N6VwjKuM6VCthI384NLqDQcY4vLl69Ug1GA02pfybm0JvgWFP0UGcfZ0ODeVuxvYwluCoGYIGwI/whwXpSf54kjFlDLMBTdu1z2F5HmeLGq2iTcbEnvdAoAW7YV4qcKnebPJGtarxxwGsRDC4Pwua+Yvn0wnGnyVEGVswIDAQAB`;

export const PG_CLIENTKEY =
  process.env.REACT_APP_ENV === "production"
    ? `MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAJtNGFUgEi9oZrSAO7LWAkSw6b2B6Qq75TDABIFO3+rIZ3TVFYymlxoZZiLir5lXDGoXDWCCO7h8ZS55WoVk2OTBnprK/Eazfj6TRB+ZPiG1/huGXtf1id0eMbO+m8lInijc8kCuoi1NabHjF9POTwygrUsiFbpBd6nEIs4T5qd9AgMBAAECgYBSqn4KSfEEJTmOWTft4PcCI324L1+iJBRCl+OOBTMx4Y0YZph67u49qUlxxmKcZ/amvjCTr58ke6rMSzKBEQZWHZi2nFMF+FQn/PdjGxESXN1xwu8GYGVhkA9L7ympsQlTsBLGoSyFGrz7Vz/jRqKItFiRXqzx8DUYuWSImQ4yDQJBAPPUEDzHNKiHpOuD1PSFZxwDayl4uQrvUXbzNGWeTVjvXciAeE/LKMIEZ11t8ATnIuevLVip7rNRil+JvNGs5WcCQQCjDbkFntJsddafLVjTQqpmFWGkIIC2T+KNJlqqvExXdHZeq0B6d8cqDRrhKhhXK6PmDkUvU7xA61t0Q3Uua7l7AkAYdGNwhRY99OTQjjdUkvCleZ5M2YPNmfUUtg3CR19AlTlVu7TVY+3hj6mCUF1rUHdKv2IP63M6Xuo+7MSYTvvvAkBuZp4+Vfk4Atmc0YFxGZRypkuEa5V628ATvkJplDFEjdCP7Pgtc+hgapsmlfABJcVFwafKkbHHaxRzNjGjisD9AkEAlpcOHz496Rv/z2u4a9I/JZ0pZHlXgxQAWIun/1gYb+8CRSG6sGDi/K51N5zb0bz674LVOOUwYpDyLKzOeXa0yg==`
    : `MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKHcS8E2pRH2CXjYL4a+soKezwED9blHeCy3DMpxt3LsPAuqluX+87sWn7ERpAvShAdALKmS9cUoSoHmWNFi+1JomMbUnXR5Ausj06Viyesuos/gKu/Od5twd4Ucv1V8u50tIH6NzKRwRUmHNsh8ovI/khpNVytvJZWsEUWbjiptAgMBAAECgYEAgs5Ifl3N6wT9xKZZSjikhMEYo0Zy94fVi7Vm5dgenAZjxD3ZcwemKwTuiyepflBjmIR5U5VLf0i/Zdkk4Bpw5XAgAldQYmVqeOsTtJSUFHCukzYo0CqXKC74UfA9obbdI87Eim+rqt9Ez0jgtf1amwkvpYGXrdHvyPTU9wLd0BUCQQDS5xPT4pV6/eJK+6qN1/R12x080YoqOA989pHZd2RB5GKzHbGQQNd/Wt0Dxu9oXyLSeha1HwRu5+CcQyatfqhTAkEAxHigiX377A8MT1/GjPXnLGJjB9RGOLMr42pJPo5OALt7A8j+w/LoUZVsSaqK5V3lJjEaCl9p06m6bwWbJgKKPwJBAJJVAszhShYsUfb050HDtTqQ7ZhlSxhADX8HFetti4KslE7zK2CLnPogcXlNbo9ccyzWySqietD40j+Z2BxI5UECQQCkIJEbyt8VCE0kUcIwJ4yDC33nIHG5FBRp2nRtibun6PaO5u3NC7L/1G+t6oY1rgarrQEwAR0K8RMJhAlj62NJAkAi4g4p+liTxw/F0rCEJPG2tOqgXN21cVbP9oOzHncGkmbqIZcXnskxibZX9x7f5MvotVtJVaJTBuiDUq4GQA+X`;

// const developmentURL = process.env.REACT_APP_URL;
// export const downloadUrl = developmentURL;

// export const API_BASE_URL = `${developmentURL}/api/`;

// export const PAYMNET_CANCEL_URL = `${developmentURL}/api/PaymentResponse/PaymentCancel`;

// export const PG_BASE_URL = `${process.env.REACT_APP_PG_BASE_URL}`;

// export const PG_WT_CLIENT_CODE = `${process.env.REACT_APP_PG_WT_CLIENT_CODE}`;

// export const PG_WALLETKEY = `${process.env.REACT_APP_PG_WALLETKEY}`;

// export const PG_CLIENTKEY = `${process.env.REACT_APP_PG_CLIENTKEY}`;

export const apiCall = async (url, method, headers, data) => {
  // console.log("API_BASE_URL :  ", API_BASE_URL);
  // console.log("PAYMNET_CANCEL_URL :  ", PAYMNET_CANCEL_URL);
  // console.log("PG_BASE_URL :  ", PG_BASE_URL);
  // console.log("PG_WT_CLIENT_CODE :  ", PG_WT_CLIENT_CODE);
  // console.log("PG_WALLETKEY :  ", PG_WALLETKEY);
  // console.log("PG_CLIENTKEY :  ", PG_CLIENTKEY);
  const baseUrl = API_BASE_URL;
  const header = headers !== null ? new Headers(headers) : new Headers();

  if (headers === null) {
    header.append("Content-Type", "application/json");
  }
  const requestOptions = {
    method: method,
    headers: header,
    body: data,
  };

  return await fetch(baseUrl + url, requestOptions)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.warn(error);
    });
};

// Request Method: GET -  Call Store Process API Manage
export const apiCallSPGet = async (url, defaultRetrun = []) => {
  return apiCallSP(url, "GET", {}, null, defaultRetrun);
};

// Request Method : Post -  Call Store Process API Manage
export const apiCallSPPost = async (
  url,
  data = null,
  defaultRetrun = [],
  header = {}
) => {
  return apiCallSP(url, "POST", header, data, defaultRetrun);
};

// Request Method : Post -  Call Store Process API Manage
export const apiCallSPPut = async (
  url,
  data,
  defaultRetrun = [],
  header = {}
) => {
  return apiCallSP(url, "PUT", header, data, defaultRetrun);
};

// Request Method : Post -  Call Store Process API Manage
export const apiCallSPDelete = async (
  url,
  data = null,
  defaultRetrun = [],
  header = {}
) => {
  return apiCallSP(url, "DELETE", header, data, defaultRetrun);
};
// Call Store Process API Manage
export const apiCallSP = async (
  url,
  method,
  headers = {},
  data = null,
  defaultRetrun = []
) => {
  // const setheaders = getHeaders(false, headers);
  //console.log("setheaders dddd", url, method, headers, data, defaultRetrun);
  const setHeaders =
    headers && Object.keys(headers).length > 0
      ? headers
      : {
          Accept: "application/json",
          "Content-Type": "application/json",
        };
  const requestOptions = {
    method: method,
    headers: setHeaders,
    body: data,
  };
  try {
    // console.log("apiCallSP - API_BASE_URL : ", API_BASE_URL);
    // console.log("PAYMNET_CANCEL_URL :  ", PAYMNET_CANCEL_URL);
    // console.log("PG_BASE_URL :  ", PG_BASE_URL);
    // console.log("PG_WT_CLIENT_CODE :  ", PG_WT_CLIENT_CODE);
    // console.log("PG_WALLETKEY :  ", PG_WALLETKEY);
    // console.log("PG_CLIENTKEY :  ", PG_CLIENTKEY);
    const response = await fetch(API_BASE_URL + url, requestOptions).then(
      handleResponsesSP
    );
    //    console.log("response:", response);
    return response || ApiResponse(true, "", false, defaultRetrun, -1);
    //return await handleResponse(response);
  } catch (error) {
    // Handle any errors that occurred during the fetch
    console.error("Error fetching data:", error.message);
    //throw error; // Re-throw the error to be caught by the caller

    const errorMsg =
      error.message === "Failed to fetch"
        ? "Failed to fetch data. Please try again later."
        : error.message;
    return ApiResponse(false, errorMsg, false, defaultRetrun, -2);
  }
  // return await fetch(API_BASE_URL + url, requestOptions)
  //   .then((response) => {
  //     console.log("apiCallSP fetch if :", response);

  //     // Ensure service worker exists, and that we really are getting a JS file.
  //     if (response.status === 200) {
  //       return response;
  //     } else {
  //       // Handle non-200 responses
  //       return response;
  //     }
  //   })
  //   .catch((error) => {
  //     console.log("apiCallSP fetch error :", error);
  //     // Handle network errors
  //     return ApiResponse(
  //       false,
  //       "Network error: Could not reach the server.",
  //       false,
  //       defaultRetrun,
  //       -2
  //     );
  //   });
  // return await fetch(API_BASE_URL + url, requestOptions)
  //   .then((response) => {
  //     console.log("apiCallSP fetch if :", response);
  //     // Ensure service worker exists, and that we really are getting a JS file.
  //     if (response.status === 200) {
  //       return response;
  //     } else {
  //       console.log("apiCallSP fetch else :", response);
  //       if (
  //         response.status === 404 ||
  //         response.headers.get("content-type").indexOf("javascript") === -1
  //       ) {
  //         return response;
  //         // No service worker found. Probably a different app. Reload the page.
  //       } else {
  //         return response;
  //       }
  //     }
  //   })
  //   .catch((error) => {
  //     let errorMsg = "";
  //     if (error) errorMsg += error.message;
  //     else
  //       errorMsg +=
  //         "No internet connection found. App is running in offline mode.";

  //     return ApiResponse(false, errorMsg, false, defaultRetrun, -2);
  //   });
};

export const apiExportToExcel = async (
  pageCount,
  url,
  data,
  downloadDocumentName,
  method = "POST"
) => {
  // const setheaders = getHeaders(false, headers);
  // console.log("setheaders", setheaders);
  try {
 
    if (pageCount != null && parseInt(pageCount) > 0) {
      const requestOptions = {
        method: method,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: data,
      };

      await fetch(API_BASE_URL + url, requestOptions)
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            //alert("Somthing was wrong in Export To Excel Data");
            response
              .text()
              .then((text) => {                
                console.log("apiExportToExcel text", text);
                const data = text && JSON.parse(text);
                alert(data["message"]);
              })
              .catch((error) => {
                console.error("apiExportToExcel", error);
              });

            throw new Error("Somthing was wrong in Export To Excel Data");
          }
          return response.blob();
        })
        .then((blob) => {
          const fileURL = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = fileURL;
          a.download = downloadDocumentName;

          // Listen for the download to complete
          a.addEventListener("load", () => {
            // Clean up resources
            URL.revokeObjectURL(fileURL);
          });

          // Trigger the click event to initiate download
          a.click();
        })
        .catch((error) => {
          console.error("Error fetching or processing data:", error);
        });
    } else {
      alert("records not available");
    }
  } catch (error) {
    // Handle any errors that occurred during the fetch
    console.error("Error fetching data:", error);
    throw error; // Re-throw the error to be caught by the caller
  }
};

// Request Method: GET -  Call OLD API Manage
export const apiCallResponsePost = async (url, header, data) => {
  return apiCallResponse(url, "POST", header, data);
};

export const apiCallResponse = async (
  url,
  method = "GET",
  headers = {},
  data = null
) => {
  const requestUrl = API_BASE_URL + url;
  const header = headers !== null ? new Headers(headers) : new Headers();
  if (headers === null) {
    header.append("Content-Type", "application/json");
  }
  const requestOptions = {
    method: method,
    headers: header,
    body: data,
  };

  try {
    const response = await fetch(requestUrl, requestOptions);
    if (!response.ok) {
      //  throw new Error("Network response was not ok");
      const message = response.message || "Network response was not ok";
      return ApiResponse(false, message, false, null, -1);
    }
    const jsonData = await response.json();
    return ApiResponse(true, "success", false, jsonData, 0);
    //jsonData !== undefined && jsonData.Data.length
  } catch (error) {
    let errorMessage =
      error.message === "Failed to fetch data. Please try again later."
        ? error.message
        : "Failed to connect to the server. Please check your internet connection or try again later.";

    //  authenticationService.logout(() => {});
    //alert(errorMessage);
    //    window.location = "/login";

    console.log("apiCallResponse error", requestUrl, errorMessage);

    //handleLogoutAndRedirect();
    return ApiResponse(false, errorMessage, false, null, -2);
  }
  // return await fetch(requestUrl, requestOptions)
  //   .then((response) => {
  //     const data = response.json();
  //     console.log("apisCallOldTC response : ", data);
  //     if (response.status === 200) {
  //       console.log("apisCallOldTC response : ", data);
  //     } else {
  //       console.warn(response.message);
  //       //throw new Error("Failed to fetch data");
  //       return ApiResponse(true, response.message, false, returnData, 0);
  //     }
  //   })
  //   .catch((error) => {
  //     console.warn("error apiCallOldTC", error);
  //     return ApiResponse(true, error, false, returnData, 0);
  //   });
};

export const getHeaders = (boolToken, custheader) => {
  console.log("getHeaders 11", boolToken, custheader);
  const { authenticated } = Auth();
  if (boolToken) {
    if (authenticated) {
      return {
        Accept: "application/json",
        "Content-Type": "application/json",
        //    Authorization: `Bearer ${userdata.Token}`,
      };
    } else {
      window.location = "/";
    }
  } else {
    console.log("getHeaders authenticated: ", authenticated);
    if (authenticated) {
      return custheader === ""
        ? { Accept: "application/json", "Content-Type": "application/json" }
        : custheader;
    }
  }
};

export const handleResponsesSP = async (res) => {
  //  console.log("handleResponsesSP", res);
  return res.text().then((text) => {
    if (!res.ok) {
      try {
        if ([401, 403].indexOf(res.status) !== -1) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          authenticationService.logout(() => {
            window.location = "/login";
          });
        }
        ApiResponse(false, res.message, false, res.status, 0);
      } catch (error) {
        ApiResponse(false, error.message, false, res.status, 0);
        //return Promise.reject(error);
      }
    }

    const data = text && JSON.parse(text);
    return data; //: ApiResponse(true, "", false, data, 0);
  });
};

export function ApiResponse(
  Success,
  Message,
  IsAuthFailure = false,
  Data = [],
  TotalRecord = 0
) {
  // console.log(
  //   "ApiResponse",
  //   Success,
  //   Message,
  //   IsAuthFailure,
  //   Data,
  //   TotalRecord
  // );
  return {
    success: Success,
    message: Message,
    isAuthFailure: IsAuthFailure,
    data: Data,
    totalRecord: TotalRecord,
  };
}

export const apiDownloadDocument = async (
  documentName,
  url,
  method = "GET",
  headers = {},
  data = null
) => {
  const requestUrl = API_BASE_URL + url;

  //alert("apiDownloadDocument : ", url);
  //const requestUrl = url;
  const header = new Headers(headers);

  if (!headers["Content-Type"]) {
    header.append("Content-Type", "application/json");
  }

  const requestOptions = {
    method,
    headers: header,
    body: data ? JSON.stringify(data) : null,
  };

  try {
    const response = await fetch(requestUrl, requestOptions);
    if (!response.ok) {
      const message = response.statusText || "Network response was not ok";
      throw new Error(message);
    }

    if (response.status === 200) {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = documentName;
        alink.click();
      });
      return ApiResponse(true, "Download Successfully", false, null, 0);
    } else {
      return ApiResponse(true, "File Not Found", false, null, 0);
    }
  } catch (error) {
    const errorMessage =
      error.message === "Failed to fetch data. Please try again later."
        ? error.message
        : "File Not Found";

    console.error("Download error", requestUrl, errorMessage);

    return ApiResponse(false, errorMessage, false, null, -2);
  }
};

export const apisResponseDownload = async (
  url,
  downloadDocumentName,
  method = "GET",
  headers = {},
  data = null
) => {
  const requestUrl = API_BASE_URL + url;

  const requestOptions = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
    body: data ? JSON.stringify(data) : null,
  };

  try {
    const response = await fetch(requestUrl, requestOptions);
    if (!response.ok) {
      const errorMessage = await response.text();
      console.error("Download error", requestUrl, errorMessage);
      alert(
        JSON.parse(errorMessage).message ||
          "Something went wrong during the download."
      );
      throw new Error(errorMessage || "Network response was not ok");
    }

    const blob = await response.blob();
    const fileURL = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = downloadDocumentName;

    // Trigger the click event to initiate download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(fileURL);

    return ApiResponse(true, "Download Successfully", false, null, 0);
  } catch (error) {
    console.error("Error fetching or processing data:", error);
    return ApiResponse(false, "Download failed", false, null, 0);
  }
};
// export const apisResponseDownalod = async (
//   url,
//   downloadDocumentName,
//   method = "GET",
//   headers = {},
//   data = null
// ) => {
//   const requestOptions = {
//     method: method,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: data,
//   };
//   return await fetch(API_BASE_URL + url, requestOptions)
//     .then((response) => {
//       if (!response.ok) {
//         //alert("Somthing was wrong in Export To Excel Data");
//         response
//           .text()
//           .then((text) => {
//             console.log("apiExportToExcel text", text);
//             const data = text && JSON.parse(text);
//             alert(data["message"]);
//           })
//           .catch((error) => {
//             console.error("apiExportToExcel", error);
//           });

//         throw new Error("Somthing was wrong in Export To Excel Data");
//       }
//       return response.blob();
//     })
//     .then((blob) => {
//       const fileURL = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = fileURL;
//       a.download = downloadDocumentName;

//       // Listen for the download to complete
//       a.addEventListener("load", () => {
//         // Clean up resources
//         URL.revokeObjectURL(fileURL);
//       });

//       // Trigger the click event to initiate download
//       a.click();
//       return ApiResponse(true, "Download Successfully", false, null, 0);
//     })
//     .catch((error) => {
//       console.error("Error fetching or processing data:", error);
//       return ApiResponse(false, "Download failed", false, null, 0);
//     });
// };

export function ApiResponseDownalod(
  success,
  message,
  isRedirect,
  data,
  status
) {
  return {
    success: success,
    message: message,
    isRedirect: isRedirect,
    data: data,
    status: status,
  };
}
